import { API } from "../../../config";
import AxiosUtils from "../../../utils/AxiosUtils";
import { serverAPIPath, devServerAPIPath } from "../config/apiPath";
import { LIST_LIMIT } from "../../../constants/constants";
import Cookies from "../../../utils/Cookies";
import { InventoryWithPaginationType } from "../../../interfaces/inventoryInterface";

class ManageInventoryList {
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = {
            client_id: process.env.REACT_APP_CAINZ_CLIENT_ID,
            client_secret: process.env.REACT_APP_CAINZ_CLIENT_SECRET,
            "access-token": new Cookies("access-token").read(),
        };
    }

    async inventoryListData(
        page: number,
        limit = LIST_LIMIT.MANAGE_INVENTORY_LIST_LIMIT,
        merchantCode?: number,
        search?: string,
        flag?: any,
        isExceededQuantity?: any,
        lessThan?: string,
        colName?:string,
        order?:string
    ) {
        const response = search
            ? await new AxiosUtils(
                `${API.BASE_URL}${devServerAPIPath.MANAGE_INVENTORY_LIST}?merchant=${merchantCode}&page=${page}&limit=${limit}&search=${search}&flag=${flag}&searchByQuantity=${lessThan}&column=${colName}&order=${order ? order : ""}&isExceededQuantity=${isExceededQuantity}`,
                this.payload,
                this.headers
            ).get()
            : await new AxiosUtils(
                `${API.BASE_URL}${devServerAPIPath.MANAGE_INVENTORY_LIST}?merchant=${merchantCode}&page=${page}&limit=${limit}&flag=${flag}&searchByQuantity=${lessThan}&column=${colName}&order=${ order ? order : "" }&isExceededQuantity=${isExceededQuantity}`,
                this.payload,
                this.headers
            ).get();

        if (response?.data?.success) {
            const { data, currentPage, totalPages, currentTotalCount, totalCount } =
        response.data.data;
            const inventoryData: InventoryWithPaginationType = {
                inventories: data,
                pagination: {
                    currentPage,
                    totalPages,
                    currentTotalCount,
                    totalCount,
                },
            };
            return inventoryData;
        } else if (response?.data?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async downloadInventoryListData(
        merchantCode?: number,
        search?: string,
        flag?: any,
        isExceededQuantity?: any,
        lessThan?: string,
        colName?:string,
        order?:string,
        fileType?:any,
        displayColumns?:any[]
    ) {
        const response = search
            ? await new AxiosUtils(
                `${API.BASE_URL}${devServerAPIPath.MANAGE_INVENTORY_LIST}?merchant=${merchantCode}&search=${search}&flag=${flag}&fileType=${fileType}&searchByQuantity=${lessThan}&download=true&column=${colName}&displayColumns=${displayColumns}&order=${order ? order : ""}&isExceededQuantity=${isExceededQuantity}`,
                this.payload,
                this.headers
            ).get()
            : await new AxiosUtils(
                `${API.BASE_URL}${devServerAPIPath.MANAGE_INVENTORY_LIST}?merchant=${merchantCode}&flag=${flag}&searchByQuantity=${lessThan}&fileType=${fileType}&download=true&column=${colName}&displayColumns=${displayColumns}&order=${order ? order : ""}&isExceededQuantity=${isExceededQuantity}`,
                this.payload,
                this.headers
            ).get();

        if (response?.data?.success) {
            if(response?.data?.data) {
                const { data, currentPage, totalPages, currentTotalCount, totalCount } = response.data.data;
                const inventoryData: InventoryWithPaginationType = {
                    inventories: data,
                    pagination: {
                        currentPage,
                        totalPages,
                        currentTotalCount,
                        totalCount,
                    },
                };
                return inventoryData;
            } else {
                const message = response?.data?.message;
                return message;
            }
        }else if (response?.data?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }
    async downloadInventoryResponseCheck(url:any) {       
        const response = await new AxiosUtils(url).getRawResponse();
        if(response?.status==200){
            return true;
        }
        else{
            return false;
        }  
    }
}

export default ManageInventoryList;
